<template>
  <section class="container">
    <div class="message_box">
      <div class="message_box__info">
        1.补缴后，请您耐心等待，稍后系统将会提示。
      </div>
      <div class="message_box__info">
        2.补缴完成后，可前往我的钱包中打印电子发票。
      </div>
      <div class="message_box__info">
        3.如您补缴费用支付失败或其它问题，请及时联系客服或停车场工作人员处理。
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.container {
  color: #444444;
  .message_box {
    margin: 25px 0 0 0;
    &__info {
      padding: 0 15px 10px;
      font-size: 14px;
      line-height: 24px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
    }
  }
}
</style>
